import http, { createApi } from '@core/fetch'

export default {
  getRealPhoto: createApi('/p/wedding/mainadmin/APIMerchant/realPhoto'),
  realPhotoEdit: createApi.post(
    '/p/wedding/mainAdmin/APIMerchant/realPhotoEdit'
  ),
  groupMemberList: createApi(
    '/hps/home/localServerMerchant/fourRole/groupMemberList'
  ),
  groupList: createApi('/hps/admin/localServerMerchant/fourRole/groupList'),
  sortEmcee: createApi.post('/hps/mainAdmin/localServerMerchant/fourRole/sort'),
  mainGroupMemberList: createApi(
    '/hps/mainAdmin/localServerMerchant/fourRole/groupMemberList'
  ),
  applyGroup: createApi.post(
    '/hps/admin/localServerMerchant/fourRole/applyGroup'
  ),
  inviteList: createApi('/hps/admin/localServerMerchant/fourRole/inviteList'),
  agreeJoinGroup: createApi.post(
    '/hps/admin/localServerMerchant/fourRole/agreeJoinGroup'
  ),
  applyList: createApi('/hps/mainAdmin/localServerMerchant/fourRole/applyList'),
  dealApplyJoin: createApi.post(
    '/hps/mainAdmin/localServerMerchant/fourRole/dealApplyJoin'
  ),
  getMemberList: data =>
    http.get('/hms/merchant/adminApi/emceeMember/page', {
      body: data
    })
}
